import { styles } from "../../../theme";
import { Heading } from "./Heading";
import { Card } from "./Card";
import {
  cardSpace,
  cardSpaceMobile,
  componentSpace,
  componentSpaceMobile,
  lineHeight,
  smallSpace,
} from "../../../theme/styles";
import { useMediaQuery, useTheme } from "@mui/material";

export const WhatOurUserSay = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {/* <img
          src={logo}
          style={{
            display: "flex",
            width: "38%",
          }}
          alt="Try in Discord"
        />   */}
      <Heading
        variant={"h6"}
        style={
          isDesktop
            ? { fontSize: "15px", marginTop: componentSpace }
            : { fontSize: "15px", marginTop: componentSpaceMobile }
        }
      >
        <label style={styles.label}>Testimonials</label>
      </Heading>
      <Heading variant={"h3"} style={{ lineHeight }}>
        O que dizem nosso usuários
      </Heading>
      <Heading
        variant={"h5"}
        style={
          isDesktop
            ? {
                fontSize: "15px",
                marginTop: smallSpace,
                marginBottom: cardSpace,
              }
            : {
                fontSize: "15px",
                marginTop: smallSpace,
                marginBottom: cardSpaceMobile,
              }
        }
      >
        *** Explore as jornadas que irão ajudá-lo em sua trajetória no{" "}
        <label style={styles.label}>League of Legend </label>***
      </Heading>
      <Card md={3} xs={12}></Card>
      <Card md={3} xs={12}></Card>
      <Card md={3} xs={12}></Card>
      <Card md={3} xs={12}></Card>
      {/* <Card pathName="hero.webp" description={"Recomendações de builds com mais ganhos para campeões e matchups"}>Builds de campeões e matchups</Card>
        <Card pathName="hero2.webp" description={"Veja quais campeões estão com as melhores performances no patch atual"}>Lista dos Melhores campeões</Card>
        <Card pathName="hero3.webp" description={"Quer saber como jogar contra um campeão específico?"}>Lista dos Melhores counters</Card>
        <Card pathName="hero4.webp">Dicas micro e macro</Card>
        <Card pathName="hero5.png" description={"Um guia para jogos fáceis e difíceis"}>Dicas de matchup</Card>
        <Card pathName="hero6.png" description="Conhecimentos gerais do jogo incluem cooldowns de habilidades, preços de itens e respawn de monstros">Conhecimentos gerais do jogo</Card> */}
    </>
  );
};
